/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { apiTicketAssignableUsersPost } from '../fn/ticket/api-ticket-assignable-users-post';
import { ApiTicketAssignableUsersPost$Params } from '../fn/ticket/api-ticket-assignable-users-post';
import { apiTicketBulkPost } from '../fn/ticket/api-ticket-bulk-post';
import { ApiTicketBulkPost$Params } from '../fn/ticket/api-ticket-bulk-post';
import { apiTicketCsvPost } from '../fn/ticket/api-ticket-csv-post';
import { ApiTicketCsvPost$Params } from '../fn/ticket/api-ticket-csv-post';
import { apiTicketItemIdAssignedCommunicationsGet } from '../fn/ticket/api-ticket-item-id-assigned-communications-get';
import { ApiTicketItemIdAssignedCommunicationsGet$Params } from '../fn/ticket/api-ticket-item-id-assigned-communications-get';
import { apiTicketItemIdGet } from '../fn/ticket/api-ticket-item-id-get';
import { ApiTicketItemIdGet$Params } from '../fn/ticket/api-ticket-item-id-get';
import { apiTicketItemIdMerchantIdImpersonateTokenGet } from '../fn/ticket/api-ticket-item-id-merchant-id-impersonate-token-get';
import { ApiTicketItemIdMerchantIdImpersonateTokenGet$Params } from '../fn/ticket/api-ticket-item-id-merchant-id-impersonate-token-get';
import { apiTicketItemIdMerchantsGet } from '../fn/ticket/api-ticket-item-id-merchants-get';
import { ApiTicketItemIdMerchantsGet$Params } from '../fn/ticket/api-ticket-item-id-merchants-get';
import { apiTicketItemIdMessageMessageIdPut } from '../fn/ticket/api-ticket-item-id-message-message-id-put';
import { ApiTicketItemIdMessageMessageIdPut$Params } from '../fn/ticket/api-ticket-item-id-message-message-id-put';
import { apiTicketItemIdPrefixGet } from '../fn/ticket/api-ticket-item-id-prefix-get';
import { ApiTicketItemIdPrefixGet$Params } from '../fn/ticket/api-ticket-item-id-prefix-get';
import { apiTicketItemIdPut } from '../fn/ticket/api-ticket-item-id-put';
import { ApiTicketItemIdPut$Params } from '../fn/ticket/api-ticket-item-id-put';
import { apiTicketItemIdReassignCommunicationsPut } from '../fn/ticket/api-ticket-item-id-reassign-communications-put';
import { ApiTicketItemIdReassignCommunicationsPut$Params } from '../fn/ticket/api-ticket-item-id-reassign-communications-put';
import { apiTicketItemIdRecategorizePut } from '../fn/ticket/api-ticket-item-id-recategorize-put';
import { ApiTicketItemIdRecategorizePut$Params } from '../fn/ticket/api-ticket-item-id-recategorize-put';
import { apiTicketItemIdStatusPut } from '../fn/ticket/api-ticket-item-id-status-put';
import { ApiTicketItemIdStatusPut$Params } from '../fn/ticket/api-ticket-item-id-status-put';
import { apiTicketItemIdTypingCategoryPut } from '../fn/ticket/api-ticket-item-id-typing-category-put';
import { ApiTicketItemIdTypingCategoryPut$Params } from '../fn/ticket/api-ticket-item-id-typing-category-put';
import { apiTicketItemIdUnassignCommunicationsPut } from '../fn/ticket/api-ticket-item-id-unassign-communications-put';
import { ApiTicketItemIdUnassignCommunicationsPut$Params } from '../fn/ticket/api-ticket-item-id-unassign-communications-put';
import { apiTicketMassAssignmentPut } from '../fn/ticket/api-ticket-mass-assignment-put';
import { ApiTicketMassAssignmentPut$Params } from '../fn/ticket/api-ticket-mass-assignment-put';
import { apiTicketMassCommunicationPost } from '../fn/ticket/api-ticket-mass-communication-post';
import { ApiTicketMassCommunicationPost$Params } from '../fn/ticket/api-ticket-mass-communication-post';
import { apiTicketMassStatusPut } from '../fn/ticket/api-ticket-mass-status-put';
import { ApiTicketMassStatusPut$Params } from '../fn/ticket/api-ticket-mass-status-put';
import { apiTicketOnlineGet } from '../fn/ticket/api-ticket-online-get';
import { ApiTicketOnlineGet$Params } from '../fn/ticket/api-ticket-online-get';
import { apiTicketOverviewGet } from '../fn/ticket/api-ticket-overview-get';
import { ApiTicketOverviewGet$Params } from '../fn/ticket/api-ticket-overview-get';
import { apiTicketPost } from '../fn/ticket/api-ticket-post';
import { ApiTicketPost$Params } from '../fn/ticket/api-ticket-post';
import { apiTicketTicketIdMessagePost } from '../fn/ticket/api-ticket-ticket-id-message-post';
import { ApiTicketTicketIdMessagePost$Params } from '../fn/ticket/api-ticket-ticket-id-message-post';
import { apiTicketTicketsExportPost } from '../fn/ticket/api-ticket-tickets-export-post';
import { ApiTicketTicketsExportPost$Params } from '../fn/ticket/api-ticket-tickets-export-post';
import { ImportResponseList } from '../models/import-response-list';
import { MerchantImpersonation } from '../models/merchant-impersonation';
import { MerchantOverviewList } from '../models/merchant-overview-list';
import { Prefix } from '../models/prefix';
import { StudentMessageId } from '../models/student-message-id';
import { Ticket } from '../models/ticket';
import { TicketMessage } from '../models/ticket-message';
import { TicketOverviewList } from '../models/ticket-overview-list';
import { TicketsConnectedCount } from '../models/tickets-connected-count';
import { UserAssignedCommunications } from '../models/user-assigned-communications';
import { UserOverviewList } from '../models/user-overview-list';


/**
 * Ticket service
 */
@Injectable({ providedIn: 'root' })
export class TicketService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiTicketItemIdGet()` */
  static readonly ApiTicketItemIdGetPath = '/api/ticket/{item_id}';

  /**
   * Get a ticket if the user has access to it.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiTicketItemIdGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTicketItemIdGet$Response(params: ApiTicketItemIdGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Ticket>> {
    return apiTicketItemIdGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Get a ticket if the user has access to it.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiTicketItemIdGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTicketItemIdGet(params: ApiTicketItemIdGet$Params, context?: HttpContext): Observable<Ticket> {
    return this.apiTicketItemIdGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Ticket>): Ticket => r.body)
    );
  }

  /** Path part for operation `apiTicketItemIdPut()` */
  static readonly ApiTicketItemIdPutPath = '/api/ticket/{item_id}';

  /**
   * Update a ticket if the user has access to it.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiTicketItemIdPut()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiTicketItemIdPut$Response(params: ApiTicketItemIdPut$Params, context?: HttpContext): Observable<StrictHttpResponse<Ticket>> {
    return apiTicketItemIdPut(this.http, this.rootUrl, params, context);
  }

  /**
   * Update a ticket if the user has access to it.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiTicketItemIdPut$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiTicketItemIdPut(params: ApiTicketItemIdPut$Params, context?: HttpContext): Observable<Ticket> {
    return this.apiTicketItemIdPut$Response(params, context).pipe(
      map((r: StrictHttpResponse<Ticket>): Ticket => r.body)
    );
  }

  /** Path part for operation `apiTicketMassAssignmentPut()` */
  static readonly ApiTicketMassAssignmentPutPath = '/api/ticket/mass-assignment';

  /**
   * Mass assign tickets to a user.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiTicketMassAssignmentPut()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiTicketMassAssignmentPut$Response(params: ApiTicketMassAssignmentPut$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return apiTicketMassAssignmentPut(this.http, this.rootUrl, params, context);
  }

  /**
   * Mass assign tickets to a user.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiTicketMassAssignmentPut$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiTicketMassAssignmentPut(params: ApiTicketMassAssignmentPut$Params, context?: HttpContext): Observable<void> {
    return this.apiTicketMassAssignmentPut$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiTicketItemIdStatusPut()` */
  static readonly ApiTicketItemIdStatusPutPath = '/api/ticket/{item_id}/status';

  /**
   * Update a ticket status.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiTicketItemIdStatusPut()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiTicketItemIdStatusPut$Response(params: ApiTicketItemIdStatusPut$Params, context?: HttpContext): Observable<StrictHttpResponse<Ticket>> {
    return apiTicketItemIdStatusPut(this.http, this.rootUrl, params, context);
  }

  /**
   * Update a ticket status.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiTicketItemIdStatusPut$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiTicketItemIdStatusPut(params: ApiTicketItemIdStatusPut$Params, context?: HttpContext): Observable<Ticket> {
    return this.apiTicketItemIdStatusPut$Response(params, context).pipe(
      map((r: StrictHttpResponse<Ticket>): Ticket => r.body)
    );
  }

  /** Path part for operation `apiTicketMassStatusPut()` */
  static readonly ApiTicketMassStatusPutPath = '/api/ticket/mass-status';

  /**
   * Mass update the ticket status.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiTicketMassStatusPut()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiTicketMassStatusPut$Response(params: ApiTicketMassStatusPut$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return apiTicketMassStatusPut(this.http, this.rootUrl, params, context);
  }

  /**
   * Mass update the ticket status.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiTicketMassStatusPut$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiTicketMassStatusPut(params: ApiTicketMassStatusPut$Params, context?: HttpContext): Observable<void> {
    return this.apiTicketMassStatusPut$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiTicketPost()` */
  static readonly ApiTicketPostPath = '/api/ticket';

  /**
   * Create a ticket with role-based access and automatic tutor assignment.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiTicketPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiTicketPost$Response(params: ApiTicketPost$Params, context?: HttpContext): Observable<StrictHttpResponse<Ticket>> {
    return apiTicketPost(this.http, this.rootUrl, params, context);
  }

  /**
   * Create a ticket with role-based access and automatic tutor assignment.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiTicketPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiTicketPost(params: ApiTicketPost$Params, context?: HttpContext): Observable<Ticket> {
    return this.apiTicketPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<Ticket>): Ticket => r.body)
    );
  }

  /** Path part for operation `apiTicketOverviewGet()` */
  static readonly ApiTicketOverviewGetPath = '/api/ticket/overview';

  /**
   * Get ticket overview.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiTicketOverviewGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTicketOverviewGet$Response(params?: ApiTicketOverviewGet$Params, context?: HttpContext): Observable<StrictHttpResponse<TicketOverviewList>> {
    return apiTicketOverviewGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Get ticket overview.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiTicketOverviewGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTicketOverviewGet(params?: ApiTicketOverviewGet$Params, context?: HttpContext): Observable<TicketOverviewList> {
    return this.apiTicketOverviewGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<TicketOverviewList>): TicketOverviewList => r.body)
    );
  }

  /** Path part for operation `apiTicketTicketIdMessagePost()` */
  static readonly ApiTicketTicketIdMessagePostPath = '/api/ticket/{ticket_id}/message';

  /**
   * Legacy: Create a message.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiTicketTicketIdMessagePost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiTicketTicketIdMessagePost$Response(params: ApiTicketTicketIdMessagePost$Params, context?: HttpContext): Observable<StrictHttpResponse<StudentMessageId>> {
    return apiTicketTicketIdMessagePost(this.http, this.rootUrl, params, context);
  }

  /**
   * Legacy: Create a message.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiTicketTicketIdMessagePost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiTicketTicketIdMessagePost(params: ApiTicketTicketIdMessagePost$Params, context?: HttpContext): Observable<StudentMessageId> {
    return this.apiTicketTicketIdMessagePost$Response(params, context).pipe(
      map((r: StrictHttpResponse<StudentMessageId>): StudentMessageId => r.body)
    );
  }

  /** Path part for operation `apiTicketOnlineGet()` */
  static readonly ApiTicketOnlineGetPath = '/api/ticket/online';

  /**
   * Get user incidents connected count.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiTicketOnlineGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTicketOnlineGet$Response(params?: ApiTicketOnlineGet$Params, context?: HttpContext): Observable<StrictHttpResponse<TicketsConnectedCount>> {
    return apiTicketOnlineGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Get user incidents connected count.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiTicketOnlineGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTicketOnlineGet(params?: ApiTicketOnlineGet$Params, context?: HttpContext): Observable<TicketsConnectedCount> {
    return this.apiTicketOnlineGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<TicketsConnectedCount>): TicketsConnectedCount => r.body)
    );
  }

  /** Path part for operation `apiTicketBulkPost()` */
  static readonly ApiTicketBulkPostPath = '/api/ticket/bulk';

  /**
   * Sync tickets from an array of tickets.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiTicketBulkPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiTicketBulkPost$Response(params: ApiTicketBulkPost$Params, context?: HttpContext): Observable<StrictHttpResponse<ImportResponseList>> {
    return apiTicketBulkPost(this.http, this.rootUrl, params, context);
  }

  /**
   * Sync tickets from an array of tickets.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiTicketBulkPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiTicketBulkPost(params: ApiTicketBulkPost$Params, context?: HttpContext): Observable<ImportResponseList> {
    return this.apiTicketBulkPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<ImportResponseList>): ImportResponseList => r.body)
    );
  }

  /** Path part for operation `apiTicketCsvPost()` */
  static readonly ApiTicketCsvPostPath = '/api/ticket/csv';

  /**
   * Upload a CSV file, parse the file and import the tickets.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiTicketCsvPost()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiTicketCsvPost$Response(params: ApiTicketCsvPost$Params, context?: HttpContext): Observable<StrictHttpResponse<ImportResponseList>> {
    return apiTicketCsvPost(this.http, this.rootUrl, params, context);
  }

  /**
   * Upload a CSV file, parse the file and import the tickets.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiTicketCsvPost$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiTicketCsvPost(params: ApiTicketCsvPost$Params, context?: HttpContext): Observable<ImportResponseList> {
    return this.apiTicketCsvPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<ImportResponseList>): ImportResponseList => r.body)
    );
  }

  /** Path part for operation `apiTicketItemIdRecategorizePut()` */
  static readonly ApiTicketItemIdRecategorizePutPath = '/api/ticket/{item_id}/recategorize';

  /**
   * Recategorize a ticket and handle external API call if needed.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiTicketItemIdRecategorizePut()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiTicketItemIdRecategorizePut$Response(params: ApiTicketItemIdRecategorizePut$Params, context?: HttpContext): Observable<StrictHttpResponse<Ticket>> {
    return apiTicketItemIdRecategorizePut(this.http, this.rootUrl, params, context);
  }

  /**
   * Recategorize a ticket and handle external API call if needed.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiTicketItemIdRecategorizePut$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiTicketItemIdRecategorizePut(params: ApiTicketItemIdRecategorizePut$Params, context?: HttpContext): Observable<Ticket> {
    return this.apiTicketItemIdRecategorizePut$Response(params, context).pipe(
      map((r: StrictHttpResponse<Ticket>): Ticket => r.body)
    );
  }

  /** Path part for operation `apiTicketItemIdTypingCategoryPut()` */
  static readonly ApiTicketItemIdTypingCategoryPutPath = '/api/ticket/{item_id}/typing-category';

  /**
   * Update a ticket typing category.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiTicketItemIdTypingCategoryPut()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiTicketItemIdTypingCategoryPut$Response(params: ApiTicketItemIdTypingCategoryPut$Params, context?: HttpContext): Observable<StrictHttpResponse<Ticket>> {
    return apiTicketItemIdTypingCategoryPut(this.http, this.rootUrl, params, context);
  }

  /**
   * Update a ticket typing category.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiTicketItemIdTypingCategoryPut$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiTicketItemIdTypingCategoryPut(params: ApiTicketItemIdTypingCategoryPut$Params, context?: HttpContext): Observable<Ticket> {
    return this.apiTicketItemIdTypingCategoryPut$Response(params, context).pipe(
      map((r: StrictHttpResponse<Ticket>): Ticket => r.body)
    );
  }

  /** Path part for operation `apiTicketItemIdMerchantIdImpersonateTokenGet()` */
  static readonly ApiTicketItemIdMerchantIdImpersonateTokenGetPath = '/api/ticket/{item_id}/{merchant_id}/impersonate-token';

  /**
   * Get the impersonate token for a student.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiTicketItemIdMerchantIdImpersonateTokenGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTicketItemIdMerchantIdImpersonateTokenGet$Response(params: ApiTicketItemIdMerchantIdImpersonateTokenGet$Params, context?: HttpContext): Observable<StrictHttpResponse<MerchantImpersonation>> {
    return apiTicketItemIdMerchantIdImpersonateTokenGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Get the impersonate token for a student.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiTicketItemIdMerchantIdImpersonateTokenGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTicketItemIdMerchantIdImpersonateTokenGet(params: ApiTicketItemIdMerchantIdImpersonateTokenGet$Params, context?: HttpContext): Observable<MerchantImpersonation> {
    return this.apiTicketItemIdMerchantIdImpersonateTokenGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<MerchantImpersonation>): MerchantImpersonation => r.body)
    );
  }

  /** Path part for operation `apiTicketItemIdMerchantsGet()` */
  static readonly ApiTicketItemIdMerchantsGetPath = '/api/ticket/{item_id}/merchants';

  /**
   * Get merchant overview.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiTicketItemIdMerchantsGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTicketItemIdMerchantsGet$Response(params: ApiTicketItemIdMerchantsGet$Params, context?: HttpContext): Observable<StrictHttpResponse<MerchantOverviewList>> {
    return apiTicketItemIdMerchantsGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Get merchant overview.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiTicketItemIdMerchantsGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTicketItemIdMerchantsGet(params: ApiTicketItemIdMerchantsGet$Params, context?: HttpContext): Observable<MerchantOverviewList> {
    return this.apiTicketItemIdMerchantsGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<MerchantOverviewList>): MerchantOverviewList => r.body)
    );
  }

  /** Path part for operation `apiTicketAssignableUsersPost()` */
  static readonly ApiTicketAssignableUsersPostPath = '/api/ticket/assignable-users';

  /**
   * Get assignable users overview.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiTicketAssignableUsersPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiTicketAssignableUsersPost$Response(params: ApiTicketAssignableUsersPost$Params, context?: HttpContext): Observable<StrictHttpResponse<UserOverviewList>> {
    return apiTicketAssignableUsersPost(this.http, this.rootUrl, params, context);
  }

  /**
   * Get assignable users overview.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiTicketAssignableUsersPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiTicketAssignableUsersPost(params: ApiTicketAssignableUsersPost$Params, context?: HttpContext): Observable<UserOverviewList> {
    return this.apiTicketAssignableUsersPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<UserOverviewList>): UserOverviewList => r.body)
    );
  }

  /** Path part for operation `apiTicketItemIdAssignedCommunicationsGet()` */
  static readonly ApiTicketItemIdAssignedCommunicationsGetPath = '/api/ticket/{item_id}/assigned-communications';

  /**
   * Returns the communications assigned to a user.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiTicketItemIdAssignedCommunicationsGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTicketItemIdAssignedCommunicationsGet$Response(params: ApiTicketItemIdAssignedCommunicationsGet$Params, context?: HttpContext): Observable<StrictHttpResponse<UserAssignedCommunications>> {
    return apiTicketItemIdAssignedCommunicationsGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Returns the communications assigned to a user.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiTicketItemIdAssignedCommunicationsGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTicketItemIdAssignedCommunicationsGet(params: ApiTicketItemIdAssignedCommunicationsGet$Params, context?: HttpContext): Observable<UserAssignedCommunications> {
    return this.apiTicketItemIdAssignedCommunicationsGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<UserAssignedCommunications>): UserAssignedCommunications => r.body)
    );
  }

  /** Path part for operation `apiTicketItemIdUnassignCommunicationsPut()` */
  static readonly ApiTicketItemIdUnassignCommunicationsPutPath = '/api/ticket/{item_id}/unassign-communications';

  /**
   * Unassigns communications for a user.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiTicketItemIdUnassignCommunicationsPut()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTicketItemIdUnassignCommunicationsPut$Response(params: ApiTicketItemIdUnassignCommunicationsPut$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return apiTicketItemIdUnassignCommunicationsPut(this.http, this.rootUrl, params, context);
  }

  /**
   * Unassigns communications for a user.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiTicketItemIdUnassignCommunicationsPut$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTicketItemIdUnassignCommunicationsPut(params: ApiTicketItemIdUnassignCommunicationsPut$Params, context?: HttpContext): Observable<void> {
    return this.apiTicketItemIdUnassignCommunicationsPut$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiTicketMassCommunicationPost()` */
  static readonly ApiTicketMassCommunicationPostPath = '/api/ticket/mass-communication';

  /**
   * Start a background thread to initiate the mass communication process for multiple students.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiTicketMassCommunicationPost()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  apiTicketMassCommunicationPost$Response(params: ApiTicketMassCommunicationPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return apiTicketMassCommunicationPost(this.http, this.rootUrl, params, context);
  }

  /**
   * Start a background thread to initiate the mass communication process for multiple students.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiTicketMassCommunicationPost$Response()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  apiTicketMassCommunicationPost(params: ApiTicketMassCommunicationPost$Params, context?: HttpContext): Observable<void> {
    return this.apiTicketMassCommunicationPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiTicketItemIdReassignCommunicationsPut()` */
  static readonly ApiTicketItemIdReassignCommunicationsPutPath = '/api/ticket/{item_id}/reassign-communications';

  /**
   * Reassigns communications for a user.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiTicketItemIdReassignCommunicationsPut()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiTicketItemIdReassignCommunicationsPut$Response(params: ApiTicketItemIdReassignCommunicationsPut$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return apiTicketItemIdReassignCommunicationsPut(this.http, this.rootUrl, params, context);
  }

  /**
   * Reassigns communications for a user.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiTicketItemIdReassignCommunicationsPut$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiTicketItemIdReassignCommunicationsPut(params: ApiTicketItemIdReassignCommunicationsPut$Params, context?: HttpContext): Observable<void> {
    return this.apiTicketItemIdReassignCommunicationsPut$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiTicketItemIdPrefixGet()` */
  static readonly ApiTicketItemIdPrefixGetPath = '/api/ticket/{item_id}/prefix';

  /**
   * Get the ticket's institution prefix.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiTicketItemIdPrefixGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTicketItemIdPrefixGet$Response(params: ApiTicketItemIdPrefixGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Prefix>> {
    return apiTicketItemIdPrefixGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Get the ticket's institution prefix.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiTicketItemIdPrefixGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTicketItemIdPrefixGet(params: ApiTicketItemIdPrefixGet$Params, context?: HttpContext): Observable<Prefix> {
    return this.apiTicketItemIdPrefixGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Prefix>): Prefix => r.body)
    );
  }

  /** Path part for operation `apiTicketItemIdMessageMessageIdPut()` */
  static readonly ApiTicketItemIdMessageMessageIdPutPath = '/api/ticket/{item_id}/message/{message_id}';

  /**
   * Update a ticket message.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiTicketItemIdMessageMessageIdPut()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  apiTicketItemIdMessageMessageIdPut$Response(params: ApiTicketItemIdMessageMessageIdPut$Params, context?: HttpContext): Observable<StrictHttpResponse<TicketMessage>> {
    return apiTicketItemIdMessageMessageIdPut(this.http, this.rootUrl, params, context);
  }

  /**
   * Update a ticket message.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiTicketItemIdMessageMessageIdPut$Response()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  apiTicketItemIdMessageMessageIdPut(params: ApiTicketItemIdMessageMessageIdPut$Params, context?: HttpContext): Observable<TicketMessage> {
    return this.apiTicketItemIdMessageMessageIdPut$Response(params, context).pipe(
      map((r: StrictHttpResponse<TicketMessage>): TicketMessage => r.body)
    );
  }

  /** Path part for operation `apiTicketTicketsExportPost()` */
  static readonly ApiTicketTicketsExportPostPath = '/api/ticket/tickets-export';

  /**
   * Export tickets based on query parameters.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiTicketTicketsExportPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiTicketTicketsExportPost$Response(params: ApiTicketTicketsExportPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return apiTicketTicketsExportPost(this.http, this.rootUrl, params, context);
  }

  /**
   * Export tickets based on query parameters.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiTicketTicketsExportPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiTicketTicketsExportPost(params: ApiTicketTicketsExportPost$Params, context?: HttpContext): Observable<void> {
    return this.apiTicketTicketsExportPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
